import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Upload, Check } from 'react-feather';
import { FormTitle, FormSubtitle, FormGroup, Label, UploadBox, UploadText, UploadSubtext, FileUploadedBanner, FileName, StyledInput, CheckboxLabel, ErrorText } from '../styles';

const documentsConfig = [
    { id: 'docIncorporation', label: 'Articles of Incorporation / Organization', desc: 'Official formation document' },
    { id: 'docEIN', label: 'EIN Confirmation Letter', desc: 'IRS Form SS-4 or 147C' },
    { id: 'docAddress', label: 'Proof of Business Address', desc: 'Utility bill or lease agreement (last 90 days)' },
    { id: 'docId', label: 'Government-Issued ID', desc: 'Passport or Driver\'s License for the authorized rep' },
    { id: 'docOrgChart', label: 'Organizational Chart', desc: 'Ownership structure and percentages' },
    { id: 'docFinancialStatements', label: 'Financial Statements or Source of Funds Documentation', desc: 'Most recent tax returns, bank statements, or certified asset verification (last 2 years)' },
];

const Step4Documents = () => {
    const { register, watch, setValue, formState: { errors } } = useFormContext();
    const isFinancialInstitution = watch('isFinancialInstitution');

    const handleFileDelete = (id) => {
        setValue(id, null, { shouldValidate: true });
    };

    return (
        <div>
            <FormTitle>Required Documents</FormTitle>
            <FormSubtitle>Upload the necessary documents to verify your business identity and source of funds.</FormSubtitle>

            {documentsConfig.map(doc => {
                const fileList = watch(doc.id);
                const file = fileList && fileList.length > 0 ? fileList[0] : null;

                return (
                    <FormGroup key={doc.id}>
                        <Label>{doc.label}</Label>
                        {file ? (
                            <FileUploadedBanner>
                                <Check size={20} />
                                <FileName>{file.name}</FileName>
                                <button
                                    type="button"
                                    onClick={() => handleFileDelete(doc.id)}
                                    style={{ background: 'none', border: 'none', color: 'inherit', opacity: 0.8, cursor: 'pointer', fontSize: '13px', fontWeight: '500', textDecoration: 'underline' }}
                                >
                                    Remove
                                </button>
                            </FileUploadedBanner>
                        ) : (
                            <>
                                <UploadBox htmlFor={doc.id} $error={!!errors[doc.id]}>
                                    <Upload size={24} />
                                    <UploadText>Click to upload or drag and drop</UploadText>
                                    <UploadSubtext>{doc.desc} (PDF, JPG, PNG)</UploadSubtext>
                                </UploadBox>
                                <StyledInput
                                    type="file"
                                    id={doc.id}
                                    {...register(doc.id)}
                                    style={{ display: 'none' }}
                                    accept=".pdf,.jpg,.jpeg,.png"
                                />
                                {errors[doc.id] && <ErrorText>{errors[doc.id].message}</ErrorText>}
                            </>
                        )}
                    </FormGroup>
                );
            })}

            {isFinancialInstitution && (
                <FormGroup>
                    <Label>AML / KYC Compliance Program</Label>
                    {watch('docAMLProgram') && watch('docAMLProgram').length > 0 ? (
                        <FileUploadedBanner>
                            <Check size={20} />
                            <FileName>{watch('docAMLProgram')[0].name}</FileName>
                            <button
                                type="button"
                                onClick={() => handleFileDelete('docAMLProgram')}
                                style={{ background: 'none', border: 'none', color: 'inherit', opacity: 0.8, cursor: 'pointer', fontSize: '13px', fontWeight: '500', textDecoration: 'underline' }}
                            >
                                Remove
                            </button>
                        </FileUploadedBanner>
                    ) : (
                        <>
                            <UploadBox htmlFor="docAMLProgram" $error={!!errors.docAMLProgram}>
                                <Upload size={24} />
                                <UploadText>Click to upload your AML Program</UploadText>
                                <UploadSubtext>Required for Financial Institutions (PDF, DOCX)</UploadSubtext>
                            </UploadBox>
                            <StyledInput
                                type="file"
                                id="docAMLProgram"
                                {...register('docAMLProgram')}
                                style={{ display: 'none' }}
                                accept=".pdf,.doc,.docx"
                            />
                            {errors.docAMLProgram && <ErrorText>{errors.docAMLProgram.message}</ErrorText>}
                        </>
                    )}
                </FormGroup>
            )}

            <CheckboxLabel $error={!!errors.agreeTerms}>
                <input type="checkbox" {...register('agreeTerms')} />
                <span>
                    By proceeding, I declare on behalf of the institution and <b>under penalty of perjury</b> that the information provided is correct and complete,
                    and I agree to the{' '}
                    <button type="button" onClick={(e) => e.preventDefault()} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}>
                        NYBANQ Platform Terms
                    </button>{' '}and{' '}
                    <button type="button" onClick={(e) => e.preventDefault()} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}>
                        Privacy Policy
                    </button>.
                </span>
            </CheckboxLabel>
            {errors.agreeTerms && <ErrorText style={{ marginTop: '8px' }}>{errors.agreeTerms.message}</ErrorText>}
        </div>
    );
};

export default Step4Documents;
